
import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext } from "vue";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { $t } from "@/lib/i18nHelpers";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionAgentEarning",
  functional: true,
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  render(h: CreateElement, ctx: RenderContext) {
    return h(TransactionView, { props: { transaction: ctx.props.transaction } }, [
      h("div", [$t("Talent Rep commission")]),
    ]);
  },
});
